import { createVanIconComponent } from "./van"

const Bell = createVanIconComponent("bell")
export default Bell
